import React, { useContext, useState, useReducer, useEffect } from "react";
import { useHistory, useParams, useLocation } from "react-router-dom";
import axios from "axios"

import AuthContext from "../../../context/auth-context";
import RulesContext from "../../../context/rules-context";

import { dataFetchReducer } from "../../Utils/requestUtils";
import { listSorter } from "../utils"

import NewRulePieceDialog from "./Dialogs/NewRulePieceDialog";
import RulePieceTreeEngine from "./RulePieceTreeEngine";

function RulePieceTree(props) {

    const { events } = props

    let history = useHistory();
    let user_data = useContext(AuthContext).user_data;
    if (!user_data.roles.includes("rule_piece_viewer")) {
        history.push("");
    }

    let { rule_piece_key } = useParams();

    const [rulePieceDefinition, setRulePieceDefinition] = useState({
        rule_piece_key: rule_piece_key,
        user_variables: []
    });

    const [rulePieceErrorCode, setRulePieceErrorCode] = useState(null)

    const [rulePiece, dispatchRulePiece] = useReducer(dataFetchReducer, {
        fetchedData: null,
        isLoading: true,
        isError: false,
    });

    const [processorsVariables, dispatchProcessorsVariables] = useReducer(
        dataFetchReducer,
        { fetchedData: null, isLoading: true, isError: false }
    );

    const [company, dispatchCompany] = useReducer(dataFetchReducer, {
        fetchedData: null,
        isLoading: true,
        isError: false,
    });

    const handleRulePiece = (rulePiecePayload, requestType) => {
        dispatchRulePiece({ type: "data_fetch_init" });
        if(requestType === 'creation') {
            setTimeout(function () {
                let url = '/dash/rule_engine/rule_piece'
                axios.post(url, rulePiecePayload, {}).then(response => {
                    dispatchRulePiece({
                        type: "data_fetch_success",
                        payload: response.data
                    })
    
                    if (response.data.rule_piece_key) {
                        setRulePieceDefinition((prev) => ({ ...prev, rule_piece_key: response.data.rule_piece_key }))
                    }
                }).catch(error => {
                    if ((error.response || {}).status === 403) {
                        dispatchRulePiece({ type: "data_fetch_failure_403" })
                        setRulePieceErrorCode(403)
                    }
                    else {
                        dispatchRulePiece({ type: "data_fetch_failure" })
                        setRulePieceErrorCode((error.response || {}).status)
                    }
                });
            }, 1000);
        } else if (requestType === 'edition') {
            setTimeout(function () {
                let url = '/dash/rule_engine/rule_piece/' + rule_piece_key
                axios.put(url, rulePiecePayload, {}).then(response => {
                    dispatchRulePiece({
                        type: "data_fetch_success",
                        payload: response.data
                    })
    
                    if (response.data.rule_piece_key) {
                        setRulePieceDefinition((prev) => ({ ...prev, rule_piece_key: response.data.rule_piece_key }))
                        history.push('/rule-piece/' + response.data.rule_piece_key)
                    }
                    return true
                }).catch(error => {
                    if ((error.response || {}).status === 403) {
                        dispatchRulePiece({ type: "data_fetch_failure_403" })
                        setRulePieceErrorCode(403)
                    }
                    else {
                        dispatchRulePiece({ type: "data_fetch_failure" })
                        setRulePieceErrorCode((error.response || {}).status)
                    }
                });
            }, 1000);
        }
    }

    useEffect(() => {
        dispatchCompany({ type: "data_fetch_init" });
        if (!user_data.business_group_key) {
            const timer = setTimeout(() => {
                axios
                    .get("/dash/rule_engine/company")
                    .then((response) => {
                        dispatchCompany({
                            type: "data_fetch_success",
                            payload: response.data,
                        });
                    })
                    .catch((error) => {
                        if ((error.response || {}).status === 403)
                            dispatchCompany({ type: "data_fetch_failure_403" });
                        else if ((error.response || {}).status === 404)
                            dispatchCompany({ type: "data_fetch_failure_404" });
                        else dispatchCompany({ type: "data_fetch_failure" });
                    });
            }, 500);
            return () => {
                clearTimeout(timer);
            };
        } else {
            const timer = setTimeout(() => {
                axios
                    .get("/dash/rule_engine/companies")
                    .then((response) => {
                        dispatchCompany({
                            type: "data_fetch_success",
                            payload: response.data,
                        });
                    })
                    .catch((error) => {
                        if ((error.response || {}).status === 403)
                            dispatchCompany({ type: "data_fetch_failure_403" });
                        else if ((error.response || {}).status === 404)
                            dispatchCompany({ type: "data_fetch_failure_404" });
                        else dispatchCompany({ type: "data_fetch_failure" });
                    });
            }, 500);
            return () => {
                clearTimeout(timer);
            };
        }
    }, [user_data.business_group_key]);

    const location = useLocation();
    useEffect(() => {
        if (rulePieceDefinition.rule_piece_key !== 'new_rule_piece' && rule_piece_key !== 'new_rule_piece') {
            dispatchRulePiece({ type: "data_fetch_init" });
            const timer = setTimeout(() => {
                axios
                    .get(`/dash/rule_engine/rule_piece/${rulePieceDefinition.rule_piece_key}`)
                    .then((response) => {
                        dispatchRulePiece({
                            type: "data_fetch_success",
                            payload: response.data,
                        });
                    })
                    .catch((error) => {
                        if ((error.response || {}).status === 403)
                            dispatchRulePiece({ type: "data_fetch_failure_403" });
                        else dispatchRulePiece({ type: "data_fetch_failure" });
                    });
            }, 500);
            return () => {
                clearTimeout(timer);
            };
        }
    }, [rulePieceDefinition.rule_piece_key, rule_piece_key, location.pathname])

    useEffect(() => {
        if (rulePieceDefinition.rule_piece_key !== 'new_rule_piece') {
            dispatchProcessorsVariables({ type: "data_fetch_init" });
            const timer = setTimeout(() => {
                axios
                    .get(`/dash/rule_engine/rule_piece/${rulePieceDefinition.rule_piece_key}/processors_variables`)
                    .then((response) => {
                        dispatchProcessorsVariables({
                            type: "data_fetch_success",
                            payload: response.data,
                        });
                    })
                    .catch((error) => {
                        if ((error.response || {}).status === 403)
                            dispatchProcessorsVariables({ type: "data_fetch_failure_403" });
                        else if ((error.response || {}).status === 404)
                            dispatchProcessorsVariables({ type: "data_fetch_failure_404" });
                        else dispatchProcessorsVariables({ type: "data_fetch_failure" });
                    });
            }, 500);
            return () => {
                clearTimeout(timer);
            };
        }
    }, [rulePieceDefinition.rule_piece_key]);


    if (rulePieceDefinition.rule_piece_key === 'new_rule_piece' && company.fetchedData) {
        return (
            <NewRulePieceDialog
                setRulePieceDefinition={setRulePieceDefinition}
                companies={company.fetchedData}
                rule_piece_key={rule_piece_key}
                open={true}
                handleRulePiece={handleRulePiece}
                rulePieceErrorCode={rulePieceErrorCode}
                setRulePieceErrorCode={setRulePieceErrorCode}
            />
        )
    } else if (
        rulePiece.fetchedData &&
        processorsVariables.fetchedData &&
        !events
    ) {
        return (
            <RulesContext.Provider
                value={{
                    fields_mapper_list: listSorter(rulePiece.fetchedData.field_mapping, "description") || [],
                    processors_variables: listSorter(processorsVariables.fetchedData, "description") || [],
                    boxes: rulePiece.fetchedData.boxes || [],
                    lists: [],
                    signals_list: [],
                    scripts_list: []
                }}
            >
                <RulePieceTreeEngine
                    rulePieceDefinition={rulePiece.fetchedData}
                />
            </RulesContext.Provider>
        )
    } else if (events) {
        return (
            <NewRulePieceDialog
                setRulePieceDefinition={setRulePieceDefinition}
                companies={company.fetchedData}
                rule_piece_key={rule_piece_key}
                open={true}
                handleRulePiece={handleRulePiece}
                events={events}
                rulePieceErrorCode={rulePieceErrorCode}
                setRulePieceErrorCode={setRulePieceErrorCode}
            />
        )
    }

    return null
}

export default RulePieceTree

